import { render, staticRenderFns } from "./AddTenantClient.vue?vue&type=template&id=19e7f95a&scoped=true"
import script from "./AddTenantClient.vue?vue&type=script&lang=js"
export * from "./AddTenantClient.vue?vue&type=script&lang=js"
import style0 from "./AddTenantClient.vue?vue&type=style&index=0&id=19e7f95a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e7f95a",
  null
  
)

export default component.exports